import * as angular from 'angular';

import { getCurrentUsername, getTrialBanner } from '@mode/shared/util-js';
import { AccountFacade } from '@mode/accounts/contract';
import { UserTypes } from '@mode/shared/contract-common';

export default class TrialBannerController {
  static $inject = ['$window', 'AccountFacade'];

  public owner: any;
  public days: number;
  public trial: string;
  public state: string;
  public userDisplayName: string;
  public userEmail: string;

  constructor(
    private $window: angular.IWindowService,
    protected accountFacade: AccountFacade
  ) {}

  $onInit() {
    this.trial = getTrialBanner(this.$window.document);
    this.state = this.getTrialState(this.trial);

    if (this.state === 'active') {
      this.days = parseInt(this.trial, 10);
    }

    this.accountFacade.loadCurrentUser(getCurrentUsername(this.$window.document));
    this.accountFacade.user$.subscribe((user) => {
      if (user) {
        this.userDisplayName = user.displayName;
        this.userEmail = (user as UserTypes.AuthenticatedUser).email;
      }
    });
  }

  getTrialState(trial): string {
    if (!trial) {
      return 'off';
    }
    if (trial === 'no_connections') {
      return 'pending';
    }
    if (trial === 'trial_expired') {
      return 'expired';
    }
    return 'active';
  }
}

/**
 * @deprecated Prefer the modern `TrialBannerComponent` in @mode/shared/ui
 */
const TrialBannerComponent: angular.IComponentOptions = {
  bindings: {
    owner: '<',
  },
  template: `
<div class="trial-banner-component" ng-if="ctrl.state !== 'off'">
  <!-- @active -->
  <a ng-href="{{ ctrl.owner.billingLink }}" class="trial-banner-link trial-banner-link-{{ ctrl.days }}" ng-if="ctrl.state === 'active'" target="_self">
    <span class="trial-number">{{ ctrl.days }}</span>
    <span class="trial-text">
      <ng-pluralize
        count="ctrl.days"
        when="{'0': 'days remain', 'one': 'day remains','other': 'days remain'}">
      </ng-pluralize>
      <br />
      in your trial
    </span>
  </a>
  <!-- @expired -->
  <mode-calendly-popup-button
    ng-if="ctrl.state === 'expired'"
    user-display-name="{{ctrl.userDisplayName}}"
    user-email="{{ctrl.userEmail}}">
    <button class="trial-banner-link trial-banner-link-default">
      <span class="trial-number trial-number-mobile-only">
        0<span class="trial-dot">&dot;</span>
      </span>
      <span class="trial-text trial-banner-message-wrap">
        <span class="trial-banner-message">
          Your trial has ended
        </span>
        <br />
        Book a  call
      </span>
    </button>
  </mode-calendly-popup-button>
</div>
`,
  controller: TrialBannerController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('trialBanner', TrialBannerComponent);
